import Link from 'src/components/utils/link';
import styles from './index.sass';
import Container from 'src/components/ui/container';

function NotFoundPage() {
	return (
		<main className={styles.notFoundPage}>
			<Container className={styles.container}>
				<h1>۴۰۴</h1>
				<span>متاسفانه صفحه مورد نظر شما یافت نشد</span>

				<Link to='/'>
					بازگشت به صفحه اصلی
				</Link>
			</Container>
		</main>
	);
}

export default NotFoundPage;
